module.exports = __webpack_public_path__ + "static/media/8151987436_d05fa6aa07_b.0cafc74a.jpg";